import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { File as FileIcon, FileText, Film, Music, Upload, X } from 'lucide-react';
import { formatBytes } from '../lib/format.js';
import { cx } from './primitives.js';
function kindIcon(mime = '', name = '') {
    if (mime.startsWith('video/'))
        return Film;
    if (mime.startsWith('audio/'))
        return Music;
    if (mime.startsWith('text/') || /\.(md|txt|json|csv|pdf)$/i.test(name))
        return FileText;
    return FileIcon;
}
/** Short type label for the file-type chip (`PDF`, `PNG`, `FILE`). */
export function fileTypeLabel(mime = '', name = '') {
    const ext = /\.([a-z0-9]{1,5})$/i.exec(name)?.[1];
    if (ext)
        return ext.toUpperCase();
    return (mime.split('/')[1] ?? 'file').slice(0, 5).toUpperCase();
}
/**
 * Attachment previews: thumbnail chips for images, file-type chips for everything else, with
 * name, size, upload progress, a per-file error and a keyboard-reachable remove button.
 */
export function AttachmentChips({ items, onRemove, className, }) {
    if (!items.length)
        return null;
    return (_jsx("ul", { className: cx('vk-atts', className), "aria-label": "Attachments", children: items.map((a) => {
            const Icon = kindIcon(a.mime, a.name);
            const image = a.url && (a.mime ?? '').startsWith('image/');
            return (_jsxs("li", { className: cx('vk-att', a.status === 'error' && 'is-error'), "aria-busy": a.status === 'uploading' || undefined, children: [image ? (_jsx("img", { className: "vk-att__thumb", src: a.url, alt: "" })) : (_jsx("span", { className: "vk-att__type", "aria-hidden": "true", children: _jsx(Icon, { size: 16 }) })), _jsxs("span", { className: "vk-att__body", children: [_jsx("span", { className: "vk-att__name vk-trunc", children: a.name }), _jsx("span", { className: "vk-att__meta", children: a.status === 'error' && a.error ? (_jsx("span", { className: "vk-att__err", children: a.error })) : a.status === 'uploading' ? (_jsx("span", { children: "Encrypting and uploading\u2026" })) : (_jsxs("span", { children: [fileTypeLabel(a.mime, a.name), a.size != null ? ` · ${formatBytes(a.size)}` : ''] })) })] }), a.status === 'uploading' ? (_jsx("span", { className: "vk-att__bar", role: "progressbar", "aria-label": `Uploading ${a.name}`, "aria-valuemin": 0, "aria-valuemax": 100 })) : null, onRemove ? (_jsx("button", { type: "button", className: "vk-att__x", "aria-label": `Remove ${a.name}`, onClick: () => onRemove(a.id), children: _jsx(X, { size: 14, "aria-hidden": "true" }) })) : null] }, a.id));
        }) }));
}
/** Covers its (relatively positioned) parent while files are dragged over it. */
export function AttachmentDropOverlay({ active, label = 'Drop to attach', }) {
    if (!active)
        return null;
    return (_jsxs("div", { className: "vk-dropzone", role: "status", children: [_jsx(Upload, { size: 18, "aria-hidden": "true" }), _jsx("span", { children: label })] }));
}
//# sourceMappingURL=Attachments.js.map